import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { fetchPublicationsByResearcherPage } from 'client/ducks/publications/actions';
import { fetchResearcher } from 'client/ducks/researchers/actions';
import { getPublicationsByResearcherPage, isLoading } from 'client/ducks/publications/selectors';
import { getResearcher, isLoading as isLoadingResearcher } from 'client/ducks/researchers/selectors';
import { State } from 'client/store';

import Researcher, { DispatchProps, StateProps } from './researcher-page';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';

function mapStateToProps(state: State): StateProps {
    return {
        publications: getPublicationsByResearcherPage(state),
        data: getResearcher(state),
        isLoading: isLoading(state),
        isLoadingResearcher: isLoadingResearcher(state)
    };
}

const mapDispatchToProps = (dispatch: Dispatch, { match }: StateProps): DispatchProps => {
    const { id } = match.params;

    return {
        fetchPage: (page: number) => dispatch(fetchPublicationsByResearcherPage(id, page)),
        fetchResearcher: () => dispatch(fetchResearcher(id))
    };
};

const component = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(Researcher) as any;

component.asyncFetchData = ({ dispatch, match }: AsyncFetchDataProps) => {
    dispatch(fetchResearcher(match.params.id));
    dispatch(fetchPublicationsByResearcherPage(match.params.id));
};

export default component;
